import React from 'react';

import Alert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';

import Icons from 'consts/icons';
import { removeAlert } from 'store/actions/alert/alerts';
import { useStyles } from './AlertUseStyles';

const AlertComponent = props => {
  const { alerts, dispatch } = props;
  const [displayedAlerts, setDisplayedAlerts] = React.useState(null);
  const classes = useStyles();

  const removeAlertHandler = index => {
    dispatch(removeAlert(index));
  };

  const organizeAlertsByType = alertsObject =>
    Object.values(alertsObject).map((eachAlertArray, index) =>
      returnAlertComponent(eachAlertArray, index)
    );

  React.useEffect(() => {
    setDisplayedAlerts(organizeAlertsByType(alerts));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alerts]);

  React.useEffect(() => {
    console.log(alerts);
    const { success } = alerts;
    const { error } = alerts;
    const { warning } = alerts;
    if (success.length > 0) {
      const timeoutSuccess = setTimeout(() => {
        removeAlertHandler(success[success.length - 1].type);
      }, 5000);

      return () => {
        clearTimeout(timeoutSuccess);
      };
    }
    if (warning.length > 0) {
      const timeoutWarning = setTimeout(() => {
        removeAlertHandler(warning[warning.length - 1].type);
      }, 5000);

      return () => {
        clearTimeout(timeoutWarning);
      };
    }
    if (error.length > 0) {
      const timeoutErrors = setTimeout(() => {
        removeAlertHandler(error[error.length - 1].type);
      }, 5000);

      return () => {
        clearTimeout(timeoutErrors);
      };
    }
  }, [alerts]);

  const returnAlertComponent = (alertArray = null, index) => (
    <div key={index}>
      {alertArray.length ? (
        <div className={classes.AlertComponent}>
          {alertArray.length > 1 && (
            <div
              className={clsx(`${classes.AlertComponent}__counter`, {
                [`${classes.AlertComponent}__error-popup--color`]:
                  alertArray[0].type === 'error',
                [`${classes.AlertComponent}__success-popup--color`]:
                  alertArray[0].type === 'success',
                [`${classes.AlertComponent}__warning-popup--color`]:
                  alertArray[0].type === 'warning',
              })}
            >
              <span>{alertArray.length}</span>
            </div>
          )}
          <Alert
            variant="filled"
            severity={alertArray[alertArray.length - 1].type}
            className={`${classes.AlertComponent}__wrapper`}
          >
            <div>
              <Icons.Actions.Clear
                className={`${classes.AlertComponent}__icon--delete`}
                onClick={
                  () =>
                    removeAlertHandler(alertArray[alertArray.length - 1].type)
                  // eslint-disable-next-line react/jsx-curly-newline
                }
              />
            </div>
            <div>
              <Typography variant="h5">
                {alertArray[alertArray.length - 1].title}
              </Typography>
              <p>{alertArray[alertArray.length - 1].desc}</p>
            </div>
          </Alert>
        </div>
      ) : null}
    </div>
  );
  React.useEffect(() => {}, [displayedAlerts]);
  return (
    <>
      {displayedAlerts && (
        <div
          className={
            displayedAlerts[0].props.children ||
            displayedAlerts[1].props.children ||
            displayedAlerts[2].props.children
              ? `${classes.AlertComponent}__wrapper__all`
              : `${classes.AlertComponent}__wrapper__all--no-display`
          }
        >
          {displayedAlerts}
        </div>
      )}
    </>
  );
};

AlertComponent.propTypes = {
  alerts: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  alerts: state.alerts,
});

export default connect(mapStateToProps)(AlertComponent);
